import { Component, Inject, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, ActivatedRouteSnapshot } from '@angular/router';
import { faFacebookF, faInstagram, faTwitter } from '@fortawesome/free-brands-svg-icons';
import {
  faUser,
  faUserCircle,
  faHome,
  faSignOutAlt,
  faWrench,
  faExclamationCircle,
  faUserEdit,
  faShieldAlt,
  faBell,
  faChevronDown
} from '@fortawesome/free-solid-svg-icons';
import { MembershipService } from './core/services/membership.service';
import { SessionModel } from './core/models/session.model';
import { EventService } from './core/services/event.service';
import { DOCUMENT } from '@angular/common';
import { ConfigService } from './services/config.service';
import { EnvironmentType } from './enums/environment-type.enum';
import { SettingsService } from './services/settings.service';
import { SessionIdleService } from './services/session-idle.service';
import { takeUntil } from 'rxjs/operators';
import { SessionIdleConfigModel } from './core/models/login.model';
import { Subject, Subscription } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SessionTimeoutDialogComponent } from './components/session-timeout/session-timeout-dialog.component';

declare let ga: Function;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  public no_local_storage=false;
  public session: SessionModel = null;
  public is_nav_collapsed = true;
  public routeData: any;
  public hide_nav_bar: boolean;
  public faFacebookF = faFacebookF;
  public faInstagram = faInstagram;
  public faTwitter = faTwitter;

  // Font Awesome Icons
  faUser = faUser;
  faUserCircle = faUserCircle;
  faHome = faHome;
  faSignOutAlt = faSignOutAlt;
  faWrench = faWrench;
  faExclamationCircle = faExclamationCircle;
  faUserEdit = faUserEdit;
  faShieldAlt = faShieldAlt;
  faBell = faBell;
  faChevronDown =faChevronDown;

  public currentYear: number = new Date().getFullYear();
  public co_brand_img_url = null;
     private subscription: Subscription;
  private sessionTimeoutDialogRef: MatDialogRef<SessionTimeoutDialogComponent> | null = null;
  private destroy$ = new Subject<void>();
  constructor(public membership: MembershipService, public router: Router, private event_service: EventService, @Inject(DOCUMENT) private document, private config: ConfigService, private setting_service: SettingsService, private session_idle_service: SessionIdleService, private dialog: MatDialog) {
    this.event_service.on('session-start', (model) => {
      this.session = model;
      if(this.session)
      {
        this.load_co_brand();
      }
    });
    this.event_service.on('session-end', () => {
      this.session = null;
    });
  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        window.scrollTo(0, 0);
        ga('send', 'pageview', evt.url);

        const snapshot = this.lastChild(this.router.routerState.snapshot.root);
        this.hide_nav_bar = snapshot && snapshot.data && snapshot.data.hide_nav_bar;
      }

    });
    if(this.membership.no_local_storage){
      this.session = null;
      this.no_local_storage = true;
    }

    this.membership.GetSession().subscribe(
      data => {
        this.session = data;
        if(this.session)
        {
          this.load_co_brand();
        }
      },
      error => {
        this.session = null;
      });

    let url: string;
    switch (this.config.getEnvironmentType()) {
      case EnvironmentType.Staging:
        url = './assets/dev_favicon.png';
        break;
      case EnvironmentType.Demo:
        url = './assets/demo_favicon.png';
        break;
      default:
        url = './assets/prod_favicon.png';
        break;
    }

    const link = <HTMLLinkElement>(this.document.head.querySelector("link[rel='icon']")) || this.document.head.appendChild(this.document.createElement('link'));
    link.rel = 'icon';
    link.type = 'image/x-icon';
    link.href = url;
     this.load_session_idle();
  }

  private load_co_brand(){
    this.setting_service.GetCoBrand().subscribe(
      data => {
        this.co_brand_img_url = data?.url?.length>0 ? data.url : null;
      },
      error => {
        this.co_brand_img_url =null;
      });
  }
  private lastChild(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
    if (route.firstChild) {
      return this.lastChild(route.firstChild);
    } else {
      return route;
    }
  }

  sign_out() {
    this.membership.ClearToken();
    this.router.navigate(['/login']);
  }

  toggle_nav_collapse() {
    this.is_nav_collapsed = !this.is_nav_collapsed;
  }

  isAuthenticated() {
    return this.session && this.session.user_id;
  }


      load_session_idle(){

    this.membership.token_change$
    .pipe(takeUntil(this.destroy$))
    .subscribe(token=>{
      this.session_idle_service.stop();
       if(token && this.membership.isValidToken()){

       this.session_idle_service.GetSessionIdleSettings().subscribe((data: SessionIdleConfigModel)=>{
        if(data.enabled){
          this.session_idle_service.initialize_config(data);
          this.session_idle_service.start();
        } else{
          this.session_idle_service.stop();
        }

      });
       }else{
         this.session_idle_service.stop();
       }
    });

    this.session_idle_service.session_logout$
    .pipe(takeUntil(this.destroy$))
    .subscribe(()=>{
      this.session_idle_service.stop();
      this.membership.RedirectToLogin();
    });

    this.session_idle_service.session_warning$
    .pipe(takeUntil(this.destroy$))
    .subscribe((show: boolean) => {
      if (show && !this.sessionTimeoutDialogRef) {
        this.sessionTimeoutDialogRef = this.dialog.open(SessionTimeoutDialogComponent, {
          width: '400px',
          height: '250px',
          disableClose: true
        });
        this.sessionTimeoutDialogRef.afterClosed().subscribe(() => {
          this.sessionTimeoutDialogRef = null;
        });
      } else if (!show && this.sessionTimeoutDialogRef) {
        this.sessionTimeoutDialogRef.close();
        this.sessionTimeoutDialogRef = null;
      }
    });

  }
    ngOnDestroy(): void {
    // Unsubscribe from the observable to prevent memory leaks
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.destroy$?.next();
    this.destroy$?.complete();
  }

}
